export const MP_SUBSCRIBE_URL =
    "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkxODM5MjkwMw==&scene=124#wechat_redirect";
// 微信公众号使用介绍文章
export const MP_INTRODUCE_URL = "https://mp.weixin.qq.com/s/Kmu5czyWj02Tn1fK3bVUNA";
// 积分规则文章
export const MP_POINTS_RULE_URL = "https://mp.weixin.qq.com/s/URpOaUHvITHi4_V5vGopqQ";

export const PROTOCOL={
    PERSONAL_INFORMATION_COLLECTION:{
        title:'个人信息收集',
        url:'https://imeikan.com/protocol/personal_information.html'
    },
    INFORMATION_SHARING:{
        title:'信息共享',
        url:'https://imeikan.com/protocol/information_sharing_checklist.html'
    },
    CANCELLATION_NOTICE:{
        title:'注销须知',
        url:'https://imeikan.com/protocol/cancellation.html'
    },
    PRIVACY_AGREEMENT:{
        title:'美刊网隐私政策',
        url:'https://imeikan.com/protocol/privacy.html'
    },
    REGISTRATION_AGREEMENT:{
        title:'用户注册协议',
        url:'https://imeikan.com/protocol/registration.html'
    }
}
